import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ef9ef58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 0,
  class: "align-center",
  style: {"width":"100px","margin-top":"20vh"}
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "no-data"
}
const _hoisted_5 = { class: "title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Sem Documentos ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showSpinContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_a_spin, { indicator: _ctx.indicator }, null, 8, ["indicator"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.envelops.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_PageTitle)
                ]),
                _createVNode(_component_a_empty, { style: {"margin-top":"20vh"} }, {
                  description: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createBlock(_component_DataTable, { key: 1 }))
        ]))
  ]))
}